var map = {
	"./bucket/icon_bucket_logo.svg": "d3975",
	"./logic/icon_dashboard_blockstorage1.svg": "87cd",
	"./logic/icon_dashboard_cabinet.svg": "cbc1",
	"./logic/icon_dashboard_computerroom.svg": "79ca",
	"./logic/icon_dashboard_logic.svg": "a5fd",
	"./logic/icon_dashboard_rule.svg": "c294",
	"./logic/icon_dashboard_service.svg": "e17e",
	"./logic/icon_setup_blue14.svg": "427f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f853";